"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _PageSectionTitle = _interopRequireDefault(require("../../../components/PageSectionTitle"));

var _HomePageWhyData = _interopRequireDefault(require("./HomePageWhyData"));

var _HomePageWhyItem = _interopRequireDefault(require("./HomePageWhyItem"));

//
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    typo: (0, _defineProperty2.default)({
      color: theme.palette.text.primary,
      textDecoration: 'none',
      fontWeight: 400
    }, theme.breakpoints.down('sm'), {
      textAlign: 'center'
    }),
    categoryContainer: (0, _defineProperty2.default)({
      width: '100%',
      display: 'flex'
    }, theme.breakpoints.down('sm'), {
      flexWrap: 'wrap'
    })
  };
}, {
  name: 'SxComHomePageWhy'
});

function HomePageWhy(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_PageSectionTitle.default, {
    classes: {
      typo: classes.typo
    }
  }, t('homePageWhy/title')), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.categoryContainer
  }, _HomePageWhyData.default.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_HomePageWhyItem.default, {
      translateKey: index,
      category: i,
      key: index.toString()
    });
  })));
}

process.env.NODE_ENV !== "production" ? HomePageWhy.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    categoryContainer: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string,
    typo: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
HomePageWhy.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined
};
var _default = HomePageWhy;
exports.default = _default;